import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticleList() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-500">精选教程与指南，助你畅游社区</p>
          </div>
          <Link
            to="/category/zuixin-dizhi"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <span className="text-xs text-foreground-400">
                  {article.date}
                </span>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-time-line" />
                <span>{article.readTime} 分钟阅读</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/zuixin-dizhi"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}